"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = void 0;
const react_1 = require("react");
const LanguageContext = (0, react_1.createContext)(false);
const LanguageProvider = ({ location, children, pageContext, globalData }) => {
    return children;
};
exports.default = LanguageProvider;
const useLanguage = () => {
    return;
};
exports.useLanguage = useLanguage;
//# sourceMappingURL=language-provider.js.map